import { useState, useEffect } from "react";
import { useSelector } from "react-redux"
import styled from "styled-components"
import { useHistory } from "react-router-dom"
import { Row, Col } from "reactstrap"
import { COLORS } from "../../constants"
import { ChildCard, Modal, CustomInput, Card, CustomButton } from "../../components"
import DatePicker from 'react-date-picker';
import AddIcon from "../../assets/images/icn_add.svg";
import axios from "axios"
import ReactLoading from "react-loading"
import { capitalizeFirstLetter } from "../../features"
import { checkPasswordMatch, validateChildPassword, validateNames } from "../../features"
import { useQuery } from "../../features"
import Eye from "../../assets/images/eye.svg"
import CrossedEye from "../../assets/images/eye_crossed.svg"


const StyledCardContainer = styled.div`
    /* width: 100%; */
   
    display: flex;
    
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
// This element is created just for the spacing in the grid
const StyledGridCardWrapper = styled.div`
    padding: 5px;
`;
const EyeImage = styled.img`
    display: inline-block;
    /* top:  ${props => props.crossed ? "9px" : "14.95px"};  */
    margin-left: 5px;
    margin-top: -2px;
    cursor: pointer;
    transition: 0.2s opacity;
    &:hover{
        opacity: 0.2;
    }
  
`;
const StyledCard = styled(Card)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 15px 0px;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    cursor: pointer;
`;
//DUPLICATE CONTENT.

// const CardComponent = (levelno) => {
//     const history = useHistory();
//     return (
//         <StyledCard className="mb-3 mt-3 p-3" style={{ background: "#f2f2f2" }}>
//             <StyledCircle bgColor={colors[levelno - 1].bgColor} color={colors[levelno - 1].color}>
//                 <h1 className="mb-0">{levelno}</h1>
//             </StyledCircle>
//             <h4 className="mt-2">Level {levelno}</h4>
//             <div className="d-flex mt-2">
//                 <CustomButton
//                     bgColor={COLORS.orange}
//                     hover={COLORS.orange_hover}
//                     color={COLORS.dark_orange}
//                     onClick={() => history.replace('/dashboard')}
//                     style={{ padding: "0 20px", height: 50, fontSize: 16, marginRight: 10 }}
//                 >
//                     Try Another Level
//                 </CustomButton>
//                 <Link to="/store">
//                     <CustomButton
//                         bgColor={COLORS.green}
//                         hover={COLORS.text_green}
//                         color={COLORS.text_dark_green}
//                         style={{ padding: "0 20px", height: 50, fontSize: 16, marginLeft: 10 }}
//                     >
//                         Buy Games
//                 </CustomButton>
//                 </Link>
//             </div>
//         </StyledCard>
//     );
// };





function ParentChildScreen() {
    const query = useQuery();
    const history = useHistory();
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user);
    const role = useSelector(state => state.auth.user.user_role);
    const levelno = query.get('level_no');
    const test_score = query.get('test_score');
    const [childList, setChildList] = useState([]);
    const [childsLoading, setChildsLoading] = useState(false)
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState(null);
    const [passwordShown, setPasswordShown] = useState(false)
    const [decideLater, setDecideLater] = useState(false)
    const [loading, setLoading] = useState(false)
    const [serverError, setServerError] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [password, setPassword] = useState('')
    const [swiperVisible, setSwiperVisible] = useState(false)
    const [dateError, setDateError] = useState('')
    const [firstNameError, setFirstNameError] = useState('')
    const [lastNameError, setLastNameError] = useState('')
    const [passwordRepeat, setPasswordRepeat] = useState('')
    const [passwordError, setPasswordError] = useState('');
    const [passwordMatchError, setPasswordMatchError] = useState('');
    //CHild modal register
    const [toggleContent, setToggleContent] = useState(true);


    useEffect(() => {
        // console.log(user.email)
        if (query.get('test_score')) {
            setVisible(true)
        }


        setChildsLoading(true)
        axios.get(`${api}/pt/pupils_by_pt/${user.email}`, {},
            {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(res => {
                const result = res.data;
                if (result.length != 0) {
                    setChildList(result)
                    // console.log(result)
                    setTimeout(() => {
                        setChildsLoading(false)
                    }, 800)

                } else {
                    setChildsLoading(false)
                }

            }).catch(error => {
                // console.log(error);
                setChildsLoading(false)

            });
    }, [])
    const createChildSubmit = () => {
        let day;
        let month;
        let year;
        let correct = true;
        if (value) {
            let date = new Date(value);
            console.log(date)
            year = date.getFullYear();
            month = date.getMonth() + 1;
            day = date.getDate();

            var now = new Date();
            if (now < date) {
                correct = false;
                setDateError("Check your child's birthdate")
            }
        }

        if (!validateNames(firstName)) {
            correct = false;
            setFirstNameError("Check the child's first name")
        }
        if (!validateNames(lastName)) {
            correct = false;
            setLastNameError("Check the child's last name")
        }
        if (!validateChildPassword(password)) {
            correct = false;
            setPasswordError('Check your password')
        }
        if (!checkPasswordMatch(password, passwordRepeat)) {
            correct = false;
            setPasswordMatchError('Passwords do not match')
        }
        if (correct) {
            setLoading(true)
            axios.post(`${api}/register_cp`, {
                pt_email: user.email,
                password: password,
                password_confirmation: passwordRepeat,
                first_name: firstName,
                last_name: lastName,
                birth_day: day,
                birth_month: month,
                birth_year: year
            },
                {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(res => {
                    const result = res.data;
                    setLoading(false)
                    // console.log(result)
                    if (result.status == "error") {
                        setModalVisible(true)
                        setVisible(false);
                        setServerError(result.message)
                    }
                    if (result.pupil) {
                        setVisible(false)
                        // console.log("zaszlo")
                        window.location.replace('/dashboard')
                    }
                }).catch(error => {
                    // console.log(error);
                    setLoading(false)
                    setVisible(false)
                });
        }
    }

    return (
        <StyledCardContainer>

            <Modal modalVisible={visible} onClose={() => {
                setVisible(false)
                history.replace('/dashboard')
                window.location.reload();
            }}>
                <div className="pl-4 pr-4">
                    {/* {toggleContent ?
                        <>
                            <h4 className="text-center color-text-dark-blue">Add Child</h4>
                            {test_score ? null : <h5 className="mb-0 mt-2 text-center" style={{ fontSize: 18 }}>We'll help you to select a level</h5>}

                            {test_score ?
                                <div className="mt-4">{TestResults(levelno, test_score)}</div>
                                :
                                <StyledCardContainer>
                                    {colors.map((color, i) => {
                                        return <StyledGridCardWrapper className="grid-card" key={i}>
                                            <StyledCard>
                                                <StyledCircle bgColor={color.bgColor} color={color.color}>
                                                    <h1 className="mb-0">{i + 1}</h1>
                                                </StyledCircle>
                                                <h4 className="mt-2">Level {i + 1}</h4>
                                                <Link to={`/test_game/${i + 1}`}>
                                                    <CustomButton
                                                        bgColor={COLORS.green}
                                                        hover={COLORS.text_green}
                                                        color={COLORS.text_dark_green}
                                                        style={{ padding: "0 15px", height: 40, fontSize: 13 }}
                                                    >
                                                        Test This Level
                                                    </CustomButton>
                                                </Link>
                                            </StyledCard>
                                        </StyledGridCardWrapper>
                                    })}
                                </StyledCardContainer>}

                            <div className="d-flex justify-content-between">

                                <div className="d-flex align-items-center">
                                    <div className="circle-sm" style={{ background: COLORS.green, cursor: "pointer" }} onClick={() => setDecideLater(!decideLater)}>
                                        {decideLater && <TiTick size={40} color={COLORS.text_dark_green} />}
                                    </div>
                                    <div className="ml-1">I'll decide later</div>
                                </div>
                                <CustomButton
                                    bgColor={COLORS.green}
                                    hover={COLORS.darker_green}
                                    color={COLORS.text_dark_green}
                                    disabled={!decideLater}
                                    onClick={() => setToggleContent(false)}
                                    style={{ padding: "0 40px", height: 50, fontSize: 16, marginTop: 10 }}
                                >
                                    Next
                                </CustomButton>
                            </div>

                        </>
                        : */}
                    <>
                        <h4 className="color-text-dark-blue">Add Child</h4>
                        {/* <h5 className="mb-0" style={{ fontSize: 18 }}>Child Details</h5> */}
                        <Row>
                            <Col lg={6} className="mt-3">
                                <h6>Name</h6>
                                <CustomInput name="name" className="w-100" value={firstName} onChange={(e) => {
                                    setFirstName(e.target.value)
                                    setFirstNameError('')
                                }} />
                                <div className="text-left mt-2" style={{ fontSize: 14, color: "red" }}>{firstNameError}</div>
                            </Col>
                            <Col lg={6} className="mt-3">
                                <h6>Surname</h6>
                                <CustomInput name="surname" className="w-100" value={lastName} onChange={(e) => {
                                    setLastName(e.target.value)
                                    setLastNameError('')
                                }} />
                                <div className="text-left mt-2" style={{ fontSize: 14, color: "red" }}>{lastNameError}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div style={{ fontSize: 14 }} className="color-text-grey">First name and surname required</div>
                            </Col>
                        </Row>
                        <h6 className="mt-3">Birthday (Optional)</h6>
                        <DatePicker
                            onChange={(date) => {
                                setValue(date)
                                setDateError('');
                            }}
                            dateFormat="dd/MM/yyyy"
                            value={value}
                        />
                        <div className="text-left mt-2" style={{ fontSize: 14, color: "red" }}>{dateError}</div>
                        <Row>
                            <Col lg={6}>
                                <div>
                                    <h6 className="d-inline-block mt-3">Password</h6>
                                    <EyeImage crossed={passwordShown} src={passwordShown ? Eye : CrossedEye} width="25" onClick={() => setPasswordShown(!passwordShown)} />
                                </div>
                                <CustomInput name="password" className="w-100" type={passwordShown ? "text" : "password"} value={password} onChange={(e) => {
                                    setPassword(e.target.value)
                                    setPasswordError('')
                                }} />

                            </Col>
                            <Col lg={6} className="mt-3">
                                <h6> Repeat Password</h6>
                                <CustomInput name="passwordrepeat" className="w-100" type={passwordShown ? "text" : "password"} value={passwordRepeat} onChange={(e) => setPasswordRepeat(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div style={{ fontSize: 14 }} className="color-text-grey">Password should contain at least 5 lowercase letters</div>
                                <div className="text-left mt-2" style={{ fontSize: 14, color: "red" }}>{passwordError}</div>
                            </Col>
                        </Row>
                        <Row className="mx-0 mt-3">
                            <Col>
                                {!checkPasswordMatch(password, passwordRepeat) && <div className="text-center" style={{ fontSize: 14, color: "red" }}>{passwordMatchError}</div>}
                            </Col>
                        </Row>
                        <div>We generate a unique ID for your child and you create the password. Child can then access games without going through parent account.</div>
                        <div className="d-flex justify-content-between mt-3">

                            <CustomButton
                                bgColor={COLORS.orange}
                                hover={COLORS.orange_hover}
                                color={COLORS.dark_orange}
                                disabled={!decideLater}
                                onClick={() => setToggleContent(true)}

                                style={{ padding: "0 40px", height: 50, fontSize: 16, marginTop: 10 }}
                            >
                                Back
                                </CustomButton>

                            <CustomButton
                                bgColor={COLORS.green}
                                hover={COLORS.darker_green}
                                color={COLORS.text_dark_green}
                                disabled={!decideLater}

                                disabled={loading}
                                onClick={createChildSubmit}
                                style={{ padding: "0 40px", height: 50, fontSize: 16, marginTop: 10 }}
                            >
                                {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Add Now'}
                            </CustomButton>
                        </div>
                    </>
                    {/* } */}
                </div>
            </Modal >
            {
                childList.length === 0 && !childsLoading ?
                    <div className="w-100 d-flex align-items-center flex-column mt-5">
                        <StyledGridCardWrapper style={{ width: 250 }} onClick={() => setVisible(true)}>
                            <StyledCard className="d-flex align-items-center justify-content-center" style={{ height: "100%", margin: 0 }}>
                                <img src={AddIcon} style={{ width: 80, height: 80 }} />
                            </StyledCard>
                        </StyledGridCardWrapper>
                        {role == 1 ? <div>
                            <h5 className="color-text-green text-center mt-3">There are no children in your account</h5>
                            <h6 className="color-text-grey text-center">Press button and add up to 6 children now!</h6>
                        </div> : <div>
                            <h5 className="color-text-green text-center mt-3">There are no pupils in your account</h5>
                            <h6 className="color-text-grey text-center">Press button and add up to 30 pupils now!</h6></div>}

                    </div>
                    :
                    <>
                        {childsLoading ?
                            <div className="w-100 d-flex justify-content-center">
                                <ReactLoading type="bubbles" color={COLORS.green} height={130} width={200} />
                            </div>
                            :
                            <>
                                {childList.map((child, i) => {
                                    return <ChildCard key={i} avatar={child.avatar_id} uid={child.id} name={capitalizeFirstLetter(child.first_name) + " " + capitalizeFirstLetter(child.last_name)} />
                                })}
                                {childList.length != 6 &&
                                    <StyledGridCardWrapper className="grid-card" onClick={() => setVisible(true)}>
                                        <StyledCard className="d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                                            <img src={AddIcon} style={{ width: 80, height: 80 }} />
                                        </StyledCard>
                                    </StyledGridCardWrapper>
                                }
                            </>
                        }

                    </>
            }
        </StyledCardContainer >
    );
}

export default ParentChildScreen;